import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { DialogTitle, Stack } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { useAssetRegisterNameValidation } from "../../asset-register/hooks/use-asset-register-name-validation"
import { assetRegisterNames } from "routes/asset-register/controller/asset-register-names"
import { emptyArray } from "lib/empty-array"

export function CreateRegisterDialog({ source }) {
    const registerItems = assetRegisterNames.useResults() ?? emptyArray

    const { isValid } = useAssetRegisterNameValidation(source)

    return (
        <DataInputDialog initialValue={source} okDisabled={isValid} beforeOk={prepareOutput}>
            <DialogTitle sx={{ mb: 3 }}>{source ? "Edit" : "Add"} Asset Register</DialogTitle>

            <Stack spacing={2} sx={{ mx: 3 }} data-cy="edit-register-dialog">
                <BoundTextField
                    autoFocus
                    field="name"
                    label="Title"
                    inputProps={{ maxLength: 100 }}
                    yup={validateRegisterName}
                />
                <BoundTextField
                    field="description"
                    multiline
                    minRows={4}
                    inputProps={{ maxLength: 500, "data-cy": "register-description-input" }}
                    transformOut={trimStart}
                    transformOutOnBlur={trimStart}
                    updateValueOnBlur={false}
                    yup="string.trim.notRequired.matches(/^[^<>]*$/, 'These characters are not allowed').matches(/^(?:$|.{5,})$/, 'At least 5 characters required')"
                />
            </Stack>
        </DataInputDialog>
    )

    function validateRegisterName(value, yup) {
        return yup
            .string()
            .trim()
            .required()
            .test(
                "duplicate-register-name",
                `There is already an item named: '${getTrimmedName(value)}'. Please try again`,
                () => !isNameDuplicate(value)
            )
            .validateSync(value)
    }

    function isNameDuplicate(value) {
        const normalisedName = normaliseName(value)
        if (!normalisedName) return false
        return getComparableNames().some((name) => name === normalisedName)
    }

    function getComparableNames() {
        return registerItems
            .filter((item) => !isCurrentRegister(item))
            .map((item) => normaliseName(item?.name))
            .filter(Boolean)
    }

    function isCurrentRegister(item) {
        if (!source?.id) return false
        return item?.id === source.id
    }

    function normaliseName(value) {
        const trimmedName = getTrimmedName(value)
        return trimmedName.toLowerCase()
    }

    function getTrimmedName(value) {
        if (value === null || value === undefined) return ""
        return String(value).trim()
    }

    function trimStart(value) {
        if (value === null || value === undefined) return ""
        return String(value).trimStart()
    }

    function prepareOutput(value) {
        if (!value) return value
        return {
            ...value,
            name: value?.name?.trim(),
        }
    }
}
